// Mock data for the validation platform

export const validationServices = [
  {
    id: 1,
    title: "Validación de Identidad",
    description: "Verifica identidades de personas naturales con fuentes oficiales",
    icon: "user-check",
    features: ["Cédula de ciudadanía", "Antecedentes judiciales", "Listas restrictivas", "Procuraduría y Policía"]
  },
  {
    id: 2,
    title: "Validación Empresarial", 
    description: "Análisis completo de empresas y contrapartes comerciales",
    icon: "building-2",
    features: ["RUT y cámara de comercio", "Estados financieros", "Representante legal", "Procesos judiciales"]
  },
  {
    id: 3,
    title: "Validación Vehicular",
    description: "Consulta estado legal y técnico de vehículos",
    icon: "car", 
    features: ["SOAT vigente", "Revisión tecnomecánica", "Reportes de hurto", "Datos del propietario"]
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Básico",
    price: 50000,
    period: "mes",
    consultations: 100,
    features: [
      "100 consultas mensuales",
      "Validación de identidad básica", 
      "Soporte por email",
      "Dashboard web"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Profesional", 
    price: 150000,
    period: "mes",
    consultations: 500,
    features: [
      "500 consultas mensuales",
      "Todas las validaciones",
      "API REST incluida",
      "Soporte prioritario",
      "Reportes avanzados"
    ],
    popular: true
  },
  {
    id: 3,
    name: "Empresarial",
    price: 400000,
    period: "mes", 
    consultations: 2000,
    features: [
      "2000 consultas mensuales",
      "Integración WhatsApp",
      "Soporte dedicado",
      "Monitoreo continuo",
      "Cumplimiento SAGRILAFT"
    ],
    popular: false
  }
];

export const recentValidations = [
  {
    id: 1,
    type: "person",
    document: "1234567890",
    name: "Juan Pérez González",
    status: "approved",
    riskLevel: "low",
    date: "2024-01-15T10:30:00Z",
    findings: 0
  },
  {
    id: 2,
    type: "company", 
    document: "900123456-1",
    name: "Empresa Demo S.A.S",
    status: "review",
    riskLevel: "medium",
    date: "2024-01-15T09:15:00Z",
    findings: 2
  },
  {
    id: 3,
    type: "vehicle",
    document: "ABC123",
    name: "Chevrolet Spark 2020",
    status: "rejected",
    riskLevel: "high", 
    date: "2024-01-15T08:45:00Z",
    findings: 5
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Juan Pablo Chaustre",
    role: "Gerente General",
    company: "Staffing Solutions",
    content: "Inicialmente, el proceso de validación de antecedentes solía tomar entre catorce y quince días. Pero ahora hemos logrado reducirlo a tan solo tres días.",
    rating: 5
  },
  {
    id: 2,
    name: "Pedro Felipe Estrada", 
    role: "Presidente",
    company: "Casalimpia",
    content: "Nos ayuda en tiempo real a obtener la información de los candidatos, agilizando nuestro proceso de selección.",
    rating: 5
  },
  {
    id: 3,
    name: "Adriana Díaz",
    role: "Oficial de Cumplimiento", 
    company: "Staffing",
    content: "Se convirtió en el aliado estratégico para darle cumplimiento a nuestras políticas internas y realizar la validación de la contraparte.",
    rating: 5
  }
];

export const mockUser = {
  id: 1,
  name: "Usuario Demo",
  email: "demo@nika.co",
  plan: "Profesional",
  consultationsUsed: 47,
  consultationsLimit: 500,
  joinDate: "2024-01-01"
};